import {
  CognitoUser,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js';
import userPool from './userPool';

export const loginUser = (username, password) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: username, Pool: userPool });
    const authDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });

    user.authenticateUser(authDetails, {
      onSuccess: session => {
        const token = session.getIdToken().getJwtToken();
        localStorage.setItem('token', token);
        resolve(session);
      },
      onFailure: err => {
        reject(err);
      },
    });
  });
};

export const signupUser = async ({ username, phone, password }) => {
  const response = await fetch('/api/auth/signup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, phone, password }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Signup failed');
  }

  return response.json();
};


export const getToken = () => localStorage.getItem('token');